import { Injectable } from '@angular/core';
import { ProblemDetails, ValidationProblemDetails } from '@tfagency/authority/data-access';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  // Errors are transient one-off events, not retained state. Using a plain Subject means a
  // component that subscribes later (e.g. the next step in a route-based flow) does NOT replay a
  // stale error from a previous step. `new ReplaySubject(0)` was intended to be no-replay but
  // still replays the last value in RxJS 7.x, which caused errors to persist across navigation.
  private notFoundError: Subject<ProblemDetails> = new Subject();
  public notFoundError$ = this.notFoundError.asObservable();

  private validationError: Subject<ValidationProblemDetails> = new Subject();
  public validationError$ = this.validationError.asObservable();

  private internalServerError: Subject<ProblemDetails> = new Subject();
  public internalServerError$ = this.internalServerError.asObservable();

  private notReachableError: Subject<string> = new Subject();
  public notReachableError$ = this.notReachableError.asObservable();

  public publishError(httpError: any): void {
    switch (httpError.status) {
      case 404: {
        this.notFoundError.next(httpError.detail as ProblemDetails);
        break;
      }
      case 400: {
        this.validationError.next(httpError.error as ValidationProblemDetails);
        break;
      }
      case 500: {
        this.internalServerError.next(httpError.title as ProblemDetails);
        break;
      }
      default: {
        let serverOfflineError = '';
        if (!localStorage.getItem('languageCode')) {
          this.notReachableError.next('Anslutningen till servern bröts, var vänlig försök igen');
          return;
        }

        if ((localStorage.getItem('languageCode') as string) === 'sv') {
          serverOfflineError = 'Anslutningen till servern bröts, var vänlig försök igen';
        } else {
          serverOfflineError = 'Server is not reachable, please try again';
        }
        this.notReachableError.next(serverOfflineError);
        break;
      }
    }
  }
}
